"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToolbarPropsContext = exports.ToolbarPropsContextProvider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
const ToolbarPropsContext = (0, _lodestarUtils.createContext)({
  omitButtonGroupSeparators: false,
  renderOn: "canvas"
}, "ToolbarPropsContext");
/**
 * A generic context provider for passing props to deeper Toolbar components.
 */
const ToolbarPropsContextProvider = _ref => {
  let {
    children,
    omitButtonGroupSeparators,
    renderOn
  } = _ref;
  const memoizedValue = (0, _react.useMemo)(() => ({
    omitButtonGroupSeparators,
    renderOn
  }), [omitButtonGroupSeparators, renderOn]);
  return /*#__PURE__*/_react.default.createElement(ToolbarPropsContext.Provider, {
    value: memoizedValue
  }, children);
};
exports.ToolbarPropsContextProvider = ToolbarPropsContextProvider;
const useToolbarPropsContext = () => (0, _react.useContext)(ToolbarPropsContext);
exports.useToolbarPropsContext = useToolbarPropsContext;
//# sourceMappingURL=ToolbarPropsContext.js.map